import constants from '@/constants'

export default {
  setAppointments(state, appointments) {
    state.appointments = appointments
  },
  setDeadlineNow(state, deadlineNow) {
    state.deadlineNow = deadlineNow
  },
  setRegistered(state, appointmentId) {
    if (!state.appointments) {
      // eslint-disable-next-line
      console.error('no appointments loaded')
      return
    }
    const appointment = state.appointments[parseInt(appointmentId)]
    if (!appointment) {
      // eslint-disable-next-line
      console.error('appointment not found')
      return
    }

    appointment.participants_count++
    appointment.user_participates = true
  },
  setUnregistered(state, appointmentId) {
    if (!state.appointments) {
      // eslint-disable-next-line
      console.error('no appointments loaded')
      return
    }
    const appointment = state.appointments[parseInt(appointmentId)]
    if (!appointment) {
      // eslint-disable-next-line
      console.error('appointment not found')
      return
    }

    appointment.participants_count--
    appointment.user_participates = false
  },
  setSearchQuery(state, query) {
    state.searchQuery = query
  },
  setFilter(state, filter) {
    state.filter = filter
  },
  setSort(state, sort) {
    state.sort = sort
  },
  toggleCategoryFilter(state, categoryId) {
    const index = state.activeCategoryFilters.indexOf(categoryId)
    if (index === -1) {
      state.activeCategoryFilters.push(categoryId)
    } else {
      state.activeCategoryFilters.splice(index, 1)
    }
  },
  setSearchOpen(state, searchOpen) {
    state.searchOpen = searchOpen
  },
  resetFilters(state) {
    state.searchQuery = ''
    state.filter = constants.APPOINTMENTS.FILTER_UPCOMING
    state.sort = constants.APPOINTMENTS.SORT_RELEVANT
    state.activeCategoryFilters = []
    state.searchOpen = false
  },
}
